import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox'; // Use a lightbox library
import 'react-image-lightbox/style.css'; // Import CSS for the lightbox
import { Helmet } from 'react-helmet';

const PortfolioSection = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
  const images = [
    "/images/our-fleet/1.jpg",
    "/images/our-fleet/2.jpg",
    "/images/our-fleet/3.jpg",
    "/images/our-fleet/4.jpg",
    "/images/our-fleet/5.jpg",
    "/images/our-fleet/6.jpg",
    "/images/our-fleet/7.jpg",
    "/images/our-fleet/8.jpg",
    "/images/our-fleet/9.jpg",
    "/images/our-fleet/10.jpg",
    "/images/our-fleet/11.jpg",
    "/images/our-fleet/12.jpg",
    "/images/our-fleet/14.jpg",
    "/images/our-fleet/15.jpg",
    "/images/our-fleet/16.jpg",
    "/images/our-fleet/17.jpg",
  ];

  const vehicleNames = [
    "TOYOTA ETIOS",
    "ERITGA",
    "SWIFT DESIRE",
    "AURA",
    "INNOVA CRYSTA",
    "SCORPIO",
    "AUDI",
    "TAVERA",
    "KIA Carens",
    "TEMPO TRAVELLER",
    "MINI BUS",
    "Honda City",
    "Amaze",
    "Toyota Corolla",
    "INNOVA",
    "AC Buses "
  ];

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setIsOpen(true);
  };

  const closeLightbox = () => {
    setIsOpen(false);
  };

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div>
      <Helmet>
        <title>Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable</title>
        <meta name="description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
        <meta name="keywords" content="Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Contact: +91 8624029699 | AB Ghule Cabs | Pune to Mumbai Cabs | Affordable & Reliable" />
        <meta property="og:description" content="Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699." />
        <meta property="og:image" content="https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg" />
        <meta property="og:url" content="https://abghulecabs.com/pune-to-mumbai-cabs" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="AB Ghule Cabs" />
        
        {/* JSON-LD Structured Data for Schema Markup */}
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "AB Ghule Cabs - Pune to Mumbai Cabs",
              description: "Book reliable and affordable Pune to Mumbai cabs with AB Ghule Cabs. One-way, round-trip, airport transfers, and luxury options available. Call +91 8624029699.",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Pune, Maharashtra",
                "addressLocality": "Pune",
                "addressRegion": "Maharashtra",
                "postalCode": "411001",
                "addressCountry": "IN"
              },
              "telephone": "+91-8624029699",
              "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
              "logo": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
              "image": "https://abghulecabs.com/images/pune-to-mumbai-cabs.jpg",
              "priceRange": "₹1500 - ₹5000",
              "offers": {
                "@type": "Offer",
                "url": "https://abghulecabs.com/pune-to-mumbai-cabs",
                "priceCurrency": "INR",
                "price": "1500",
                "priceValidUntil": "2024-12-31"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "reviewCount": "1500"
              },
              "review": [
                {
                  "@type": "Review",
                  "author": {
                    "@type": "Person",
                    "name": "Sneha Kulkarni"
                  },
                  "datePublished": "2024-12-22",
                  "reviewBody": "Seamless booking process and the ride was very comfortable. Highly recommend AB Ghule Cabs for Pune to Mumbai trips."
                },
                {
                  "@type": "Review",
                  "author": {
                    "@type": "Person",
                    "name": "Vishal Sharma"
                  },
                  "datePublished": "2024-12-18",
                  "reviewBody": "Great service at an affordable price. The driver was professional and punctual."
                }
              ],
              "serviceArea": {
                "@type": "Place",
                "name": "Pune and Mumbai",
                "geo": {
                  "@type": "GeoCoordinates",
                  "latitude": "18.5204",
                  "longitude": "73.8567"
                }
              },
              "availableChannel": {
                "@type": "ServiceChannel",
                "serviceUrl": "https://abghulecabs.com/pune-to-mumbai-cabs"
              },
              "keywords": "Pune to Mumbai Cab Service, Affordable Cabs Pune to Mumbai, AB Ghule Cabs, Luxury Cabs Pune to Mumbai, Pune to Mumbai cheapest cab, Pune Mumbai Taxi Service, Pune to Mumbai Airport Cabs, Pune to Mumbai Outstation Cabs, Pune to Mumbai Cab Booking Online, Pune Mumbai Express Taxi, Pune to Mumbai Private Cabs, Pune Mumbai One-Way Taxi, Pune to Mumbai Round Trip Cabs, Pune to Mumbai Airport cab, Pune Mumbai Cab, Pune to Mumbai Taxi, Pune to Mumbai Airport Cab Fare, Pune Mumbai Airport Drop, Pune to mumbai cheapest cab, Pune to Mumbai Cab Service, best cab service Pune to Mumbai, Pune to mumbai cab fare, Pune Mumbai taxi service, Pune to Mumbai car, Pune Mumbai taxi fare, Pune to Mumbai international airport cab, Pune to Mumbai cab price, Pune to Mumbai airport cab price, Pune to Mumbai taxi one way, Pune to Mumbai cab booking, Pune to Mumbai airport taxi, Pune Mumbai cab one way"
            }
          `}
        </script>
      </Helmet>

      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className='text-white'>Gallery</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <div className="section-full site-bg-white p-t150 p-b120 twm-portfolio-wrap wow fadeInDown" data-wow-offset="100" data-wow-delay="0.2">
        <div className="container">
          <ul className="masonry-outer mfp-gallery work-grid row clearfix list-unstyled m-b0">
            {images.map((image, index) => (
              <li key={index} className={`masonry-item cat-${(index % 4) + 1} col-lg-4 col-md-6 m-b30`}>
                <div className="twm-gallery-section">
                  <a
                    className="elem media"
                    href="#"
                    onClick={() => openLightbox(index)}
                  >
                    <img src={image} alt={`Vehicle ${vehicleNames[index]}`} />
                    <span className="icon-view"><i className="feather feather-maximize"></i></span>
                  </a>
                  <div className="twm-gallery-info">
                    <h3 className="twm-title">{vehicleNames[index]}</h3>
                  </div>
                </div>
              </li>
            ))}
          </ul>

          {/* Lightbox Modal */}
          {isOpen && (
            <Lightbox
              mainSrc={images[currentImageIndex]}
              nextSrc={images[(currentImageIndex + 1) % images.length]}
              prevSrc={images[(currentImageIndex - 1 + images.length) % images.length]}
              onCloseRequest={closeLightbox}
              onMovePrevRequest={prevImage}
              onMoveNextRequest={nextImage}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PortfolioSection;
